export default __webpack_public_path__ + "static/media/sj.f170b2f3.svg";